import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-new.svg'


const _withScopeId = n => (_pushScopeId("data-v-df553c4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt-12 mb-36"
}
const _hoisted_2 = {
  id: "myModal",
  class: "modal"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-8 w-auto ml-4",
  src: _imports_0
}, null, -1))
const _hoisted_6 = { class: "h-full flex w-full space-x-4" }
const _hoisted_7 = { class: "h-full mx-auto hidden md:flex" }
const _hoisted_8 = {
  class: "h-full flex-1 max-w-full",
  style: {}
}
const _hoisted_9 = {
  class: "mx-auto h-4/6 w-auto flex items-center justify-center",
  style: {"margin-top":"32px","margin-bottom":"20px","height":"calc(100vh - 260px)"}
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "pb-6 flex gap-5 overflow-auto" }
const _hoisted_12 = ["src", "onClick"]
const _hoisted_13 = { class: "h-full mx-auto hidden md:flex" }
const _hoisted_14 = {
  key: 0,
  style: {"font-size":"32px"},
  class: "font-extrabold text-center mb-6 uppercase"
}
const _hoisted_15 = { class: "container mx-auto" }
const _hoisted_16 = { class: "w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 mb-10 px-4" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "date" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "flex justify-center" }
const _hoisted_22 = { class: "flex px-6 self-center items-center" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Page", -1))
const _hoisted_24 = { class: "flex items-center mx-3 text-center h-10 rounded border w-20 justify-center" }

import { ref, onMounted } from 'vue';
import useForest from '@/composables/useForest';
import { Icon } from '@iconify/vue';
import IconGalleryPrevious from '../components/Icons/IconGalleryPrevious.vue';
import IconGalleryNext from '../components/Icons/IconGalleryNext.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  forestGalleries,
  forestDetail,
  getForestGalleries,
  getForestDetail,
  formatDate,
} = useForest();

const galleries = ref();
const modal = ref<HTMLElement>();
const imgSelectedIndex = ref(0);
const curentPage = ref(1);
const pageInfo = ref();

onMounted(async () => {
  await getForestDetail();
  await getGallery();
  pageInfo.value = forestGalleries.value?.page_information;
  modal.value = document.getElementById('myModal') as HTMLElement;
});

const getGallery = async () => {
  await getForestGalleries({ page: curentPage.value, size: 24 });
  galleries.value = forestGalleries.value?.entities;

  curentPage.value = forestGalleries.value?.page_information.page || 1;
};
const openModalImages = (indexImg: number) => {
  imgSelectedIndex.value = indexImg;
  if (modal.value) {
    modal.value.style.display = 'block';
    (document.getElementsByTagName('BODY')[0] as HTMLElement).style.overflow =
      'hidden';
  }
};

const closeModalImage = () => {
  if (modal.value) {
    modal.value.style.display = 'none';
    (document.getElementsByTagName('BODY')[0] as HTMLElement).style.overflow =
      '';
  }
};

const changeImage = (index: number) => {
  if (imgSelectedIndex.value > 0 && index < imgSelectedIndex.value) {
    imgSelectedIndex.value = index;
  }

  if (imgSelectedIndex.value < galleries.value.length - 1 && index > 0) {
    imgSelectedIndex.value = index;
  }
};

const changePage = (i: number) => {
  if (curentPage.value > 1 && i === -1) {
    curentPage.value = curentPage.value + i;
    getGallery();
  }

  if (curentPage.value < pageInfo.value.last_page && i === 1) {
    curentPage.value = curentPage.value + i;
    getGallery();
  }
};

return (_ctx: any,_cache: any) => {
  return (galleries.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(Icon), {
                class: "h-6 w-6 text-white self-center cursor-pointer",
                onClick: closeModalImage,
                icon: "ep:close"
              }),
              _hoisted_5
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(IconGalleryPrevious, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (changeImage(imgSelectedIndex.value - 1))),
                  class: "mx-auto self-center cursor-pointer"
                })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("img", {
                    src: galleries.value[imgSelectedIndex.value].image.original_image_url,
                    alt: "",
                    class: "mx-auto h-auto w-auto max-h-full max-w-full"
                  }, null, 8, _hoisted_10)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(galleries.value, (g, i) => {
                    return (_openBlock(), _createElementBlock("img", {
                      key: i,
                      src: g.image.thumbnail_image_url,
                      onClick: ($event: any) => (changeImage(i)),
                      class: "rounded cursor-pointer object-cover",
                      style: {"width":"80px","height":"80px"}
                    }, null, 8, _hoisted_12))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(IconGalleryNext, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (changeImage(imgSelectedIndex.value + 1))),
                  class: "mx-auto self-center cursor-pointer"
                })
              ])
            ])
          ])
        ]),
        (_unref(forestDetail))
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_unref(forestDetail).name) + "," + _toDisplayString(_unref(forestDetail).country), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(galleries.value, (g, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "pb-6 w-full max-h-72"
              }, [
                _createElementVNode("figure", {
                  class: "h-full w-full cursor-pointer",
                  onClick: ($event: any) => (openModalImages(i))
                }, [
                  _createElementVNode("img", {
                    src: g.image.original_image_url,
                    class: "h-full w-full rounded-lg object-cover"
                  }, null, 8, _hoisted_18),
                  _createElementVNode("figcaption", _hoisted_19, _toDisplayString(_unref(formatDate)(g.updated_at)), 1)
                ], 8, _hoisted_17)
              ]))
            }), 128))
          ])
        ]),
        (pageInfo.value && pageInfo.value.page > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", {
                  class: "page--btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (changePage(-1)))
                }, [
                  _createVNode(_unref(Icon), {
                    class: "icon",
                    icon: "bi:chevron-left"
                  })
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("span", _hoisted_24, _toDisplayString(curentPage.value), 1),
                  _createElementVNode("span", null, "of " + _toDisplayString(pageInfo.value.last_page), 1)
                ]),
                _createElementVNode("div", {
                  class: "page--btn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (changePage(1)))
                }, [
                  _createVNode(_unref(Icon), {
                    class: "icon",
                    icon: "bi:chevron-right"
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})